<template>
  <div class="row" v-if="product_data.generated">
    <div class="col">
      <h4 class="text-center" v-if="product_data.generated.tytul">{{ product_data.generated.tytul }}</h4>
      <h4 v-else>{{ product_data.generated.tytul_magazynowy }}</h4>
      <p  class="text-center">{{ product_data.generated.podtytul }}</p>
      <div class="text-center my-1">
        <div class="my-1 w-100 btn btn-lg btn-success" @click="showModal = true, title='Półka 3 - magazyn podręczny', ipropert='półka3', currentShelf=generatedData.półka3" data-toggle="modal" data-target="#editModal">
          <span class="float-left text-uppercase">MG podręczny</span>
          <span class="float-right font-weight-bold">{{ generatedData.półka3 }}</span>
        </div>
        <div class="my-1 w-100 btn btn-lg btn-warning" @click="showModal = true, title='Półka 1 - magazyn główny', ipropert='pólka1', currentShelf=generatedData.pólka1" data-toggle="modal" data-target="#editModal">
          <span class="float-left text-uppercase">MG główny</span>
          <span class="float-right font-weight-bold">{{ generatedData.pólka1 }}</span>
        </div>
        <div class="my-1 w-100 btn btn-lg btn-danger" @click="showModal = true, title='Regał 3 - magazyn MGH', ipropert='regał3', currentShelf=generatedData.regał3" data-toggle="modal" data-target="#editModal">
          <span class="float-left text-uppercase">MG  MGH</span>
          <span class="float-right font-weight-bold">{{ generatedData.regał3 }}</span>
        </div>
        <div class="my-1 w-100 btn btn-lg btn-dark" @click="showModal = true, title='Regał - regał księgarnia', ipropert='regał', currentShelf=generatedData.regał" data-toggle="modal" data-target="#editModal">
          <span class="float-left text-uppercase">regał</span>
          <span class="float-right font-weight-bold">{{ generatedData.regał }}</span>
        </div>
        <div class="my-1 w-100 btn btn-lg btn-primary" @click="showModal = true, title='Regał 2 - magazyn księgarnia', ipropert='regał2', currentShelf=generatedData.regał2" data-toggle="modal" data-target="#editModal">
          <span class="float-left text-uppercase">regał 2</span>
          <span class="float-right font-weight-bold">{{ generatedData.regał2 }}</span>
        </div>
      </div>

      <ProductEditShelf v-if="showModal" :showModal="showModal" :title="title" :ipropert="ipropert" :currentShelf="currentShelf" @statusModal="checkStatusModal" />
      <SimpleModal v-if="showSimpleModal.status" :modalTitle="showSimpleModal.emessage" :modalBody="showSimpleModal.detail" @statusSimpleModal="statusSimpleModal" />

      <div class="my-1">
        <img v-bind:src="generatedData.okladka_sklep" class="img-fluid w-100">
      </div>

      <table class="table my-1 w-100 r_center table-dark ">
        <thead>
          <tr>
            <th scope="col" class="text-left">Magazyn</th>
            <th scope="col" class="text-left">Stan</th>
            <th scope="col" class="text-right">Zostało</th>
          </tr>
        </thead>        
        <tbody>
          <tr v-for="mg in magazynSimple" v-bind:key=mg.imagazyn class="">
            <td class="text-left">{{ mg.imagazyn }}</td>
            <td class="text-right">{{ strip(mg.stan).val }}</td>
            <td class="text-right">{{ strip(mg.zostalo).val }}</td>
          </tr>
        </tbody>
      </table>

      <div class="my-1 w-100 r_center">
        <div v-if="generatedData.cena_okladkowa" class=" clearfix">
          <span class="float-left">cena katalogowa</span>
          <span class="float-right font-weight-bold">{{ generatedData.cena_okladkowa }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import ProductEditShelf from '@/components/ProductEditShelf'
  import SimpleModal from '@/components/SimpleModal'
  // import _ from 'lodash'

  export default {
    name: 'ProductView',

    components: {
      ProductEditShelf,
      SimpleModal
    },

    data () {
      return {
        showModal: false,
        showSimpleModal: false,
        modalTitle: '',
        modalBody: ''
      }
    },

    created () {
    },

    computed: {
      ...mapState(['product_data', 'magazyn']),
      ...mapGetters(['magazynByIm']),
      magazynSimple () {
        let arr = []
        arr.push(this.magazynByIm('MG'))
        arr.push(this.magazynByIm('MGH'))
        arr.push(this.magazynByIm('MGW'))
        // arr.push(this.magazynByIm('MG+MGW'))
        arr.push(this.magazynByIm('KKH'))
        arr.push(this.magazynByIm('KKW'))
        return arr.filter(function (e) { return e })
      },
      generatedData () {
        return this.product_data.generated
      }
    },

    methods: {
      strip (nr) {
        return {
          val: nr.replace(/\.0+/g, '')
        }
      },
      checkStatusModal (value) {
        this.showModal = value[0]
        if (value[1]) {
          value[1].status = true
          this.showSimpleModal = value[1]
        } else {
          this.$emit('setFocus', true)
        }
      },
      statusSimpleModal (value) {
        this.showSimpleModal.status = value
        this.$emit('setFocus', true)
      }
    }
  }
</script>

<style scoped>
.magazyn {
  border-bottom: 1px solid #eee;
  margin: 0 auto;
}
.r_center {
  margin: 0 auto; 
}
</style>



// WEBPACK FOOTER //
// src/components/ProductView.vue